module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_d-8b779778c88089e4e81be0be1764619f.png";